module.exports = __webpack_public_path__ + "static/media/woman-gym-selected.0fb3be83.png";